// Route constants
export const ROUTE_PATHS = {
  HOME: '/',
  ABOUT: '/about',
  BUSINESS: '/business',
  BUSINESS_MEDICAL: '/business/medical',
  BUSINESS_COFFEE: '/business/coffee',
  BUSINESS_FRUITS: '/business/fruits',
  BUSINESS_AI_LIVE: '/business/ai-live',
  BUSINESS_MINERALS: '/business/minerals',
  PARTNERS: '/partners',
  NEWS: '/news',
  CONTACT: '/contact',
};

// Language type
export type Language = 'en' | 'th';

// Translation type
export type TranslationKey = string;

// Navigation items
export interface NavItem {
  label: { en: string; th: string };
  path: string;
  children?: NavItem[];
}

export const NAV_ITEMS: NavItem[] = [
  { label: { en: 'Home', th: 'หน้าแรก' }, path: ROUTE_PATHS.HOME },
  { label: { en: 'About Us', th: 'เกี่ยวกับเรา' }, path: ROUTE_PATHS.ABOUT },
  {
    label: { en: 'Business', th: 'ธุรกิจของเรา' },
    path: ROUTE_PATHS.BUSINESS,
    children: [
      { label: { en: 'Medical Devices', th: 'อุปกรณ์การแพทย์' }, path: ROUTE_PATHS.BUSINESS_MEDICAL },
      { label: { en: 'Coffee Products', th: 'ผลิตภัณฑ์กาแฟ' }, path: ROUTE_PATHS.BUSINESS_COFFEE },
      { label: { en: 'Thai Fruits', th: 'ผลไม้ไทย' }, path: ROUTE_PATHS.BUSINESS_FRUITS },
      { label: { en: 'AI Live Streaming', th: 'ไลฟ์สดด้วย AI' }, path: ROUTE_PATHS.BUSINESS_AI_LIVE },
      { label: { en: 'Global Minerals & Metals', th: 'แร่ธาตุและโลหะระดับโลก' }, path: ROUTE_PATHS.BUSINESS_MINERALS },
    ],
  },
  { label: { en: 'Partners & Compliance', th: 'พันธมิตรและการรับรอง' }, path: ROUTE_PATHS.PARTNERS },
  { label: { en: 'News & Insights', th: 'ข่าวสารและบทความ' }, path: ROUTE_PATHS.NEWS },
  { label: { en: 'Contact Us', th: 'ติดต่อเรา' }, path: ROUTE_PATHS.CONTACT },
];

// Company info
export const COMPANY_INFO = {
  name: 'Yaruwat Co., Ltd.',
  nameTh: 'บริษัท ยารุวาท จำกัด',
  slogan: { en: 'Rooted in Thailand, Bridging China, Reaching the World', th: 'รากเหง้าในไทย เชื่อมโยงจีน สู่โลกกว้าง' },
  email: 'info@yaruwat.com',
  phone: '+66 2 xxx xxxx',
  address: { en: 'Bangkok, Thailand', th: 'กรุงเทพมหานคร ประเทศไทย' },
  website: 'www.yaruwat.com',
};

// cn utility (simple version)
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
